module.exports = __webpack_public_path__ + "assets/img/5adff51380288c4b7261c7c8abcddb65.svg";